export const GET_LEADERBOARD_REQUEST = "GET_LEADERBOARD_REQUEST";
export const GET_LEADERBOARD_SUCCESS = "GET_LEADERBOARD_SUCCESS";
export const GET_LEADERBOARD_FAIL = "GET_LEADERBOARD_FAIL";
